module.exports = __webpack_public_path__ + "static/media/image 25.74340189.png";